import { Box, Typography } from '@mui/material';
import React from 'react';

function About() {
    return (
        <Box
            className="user-info-wrapper mt-5 mb-5"
            sx={{
                p: 4,
                bgcolor: '#f5f5f0',
                borderRadius: 2,
                boxShadow: 3,
                maxWidth: 800,
                mx: 'auto',
                display: 'flex',
                flexDirection: 'column',
                gap: 3,
                alignItems: 'center',
                textAlign: 'center',
                border: '1px solid #d4af37', 
            }}
        >
            <Typography
                variant="h3"
                sx={{
                    fontFamily: 'serif',
                    color: '#d4af37',
                    fontWeight: 'bold',
                }}
            >
                Tôn vinh vẻ đẹp tà Áo dài Việt Nam
            </Typography>

            <Box
                sx={{
                    width: '60px',
                    height: '2px',
                    bgcolor: '#d4af37',
                    mb: 3,
                }}
            /> 

            <Typography
                variant="body1"
                sx={{
                    fontSize: '18px',
                    fontFamily: 'Noto Serif, serif',
                    color: '#333333',
                    lineHeight: 1.8,
                }}
            >
                Áo dài từ lâu đã vượt xa khỏi một trang phục đơn thuần mà trở thành biểu tượng vĩnh cửu của văn hóa Việt Nam và của vẻ đẹp, sự duyên dáng, và sức mạnh của người phụ nữ Việt. 
                Mỗi đường nét của tà áo dài, từ cổ cao thanh thoát đến tà áo thướt tha, đều kể nên một câu chuyện về truyền thống, niềm tự hào và lòng kiên cường của dân tộc.
                <br /><br />
                Sứ mệnh của chúng tôi là tôn vinh biểu tượng quốc hồn này bằng cách mang đến những chiếc áo dài được chế tác tinh xảo, chất lượng cao và đậm chất Việt Nam. Mỗi chiếc áo dài đều được làm nên với tình yêu và sự tận tụy để giúp mỗi người phụ nữ khi khoác lên mình tà áo cảm thấy tự hào và tỏa sáng hơn.
                <br /><br />
                Chúng tôi trân trọng mời bạn khám phá và cảm nhận vẻ đẹp của tà áo dài qua từng sản phẩm.
            </Typography>
        </Box>
    );
}

export default About;
